import type React from "react";

import style from "./ProgressBar.module.css";

export type ProgressBarProps = {
  percentage: number;
  width?: number;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({ percentage, width }) => {
  const pct = Math.min(Math.max(percentage, 0), 1) * (width || 120);
  return (
    <div className={style.bgBar} style={{ ...(width && { width: width }) }}>
      <div className={style.progress} style={{ width: `${pct}px` }}></div>
    </div>
  );
};

ProgressBar.displayName = "ProgressBar";
